<template>
  <div class="family-landing-page">
    <div class="page-content container-lg">
      <h4 class="user-type">
        For family
      </h4>
      <h1>
        Don't have a tree?
      </h1>
      <div class="row">
        <div class="col-lg-6 option start">
            <div class="option-icon">
              <img src="@/assets/icons/tree_start_150.png"/>
            </div>
            <h3>
              Create your tree from scratch
            </h3>
            <div class="option-text">
              Don't worry! If no one in your family has created a family tree yet, you can be the first!
              There are tons of amazing resources to help you get started. 
            </div>
            <router-link class="btn btn-primary" to="/start/new-tree">
              Start my tree
            </router-link>
        </div>
        <div class="col-lg-6 option share">
          <div class="option-icon">
            <img src="@/assets/icons/share_tree_180.png"/>
          </div>
          <h3>
            Ask a family member to share their tree
          </h3>
          <div class="option-text">
            If you know someone that has already started building your family tree,
            contact them directly and ask them to share it with you on Tree Crossing.
          </div>
          <!-- <router-link to="/share" class="btn btn-primary">
            Search Now
          </router-link> -->
        </div>
      </div>
    </div>
  </div>
</template>

<style lang="scss" scoped>
.family-landing-page {
  flex-grow: 1;
  background-color: var(--page-bg-alt);
}

.page-content {
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 1.5rem;
  padding: 2rem 0;
}

.user-type {
  margin: 0;
  color: var(--brand-primary);
  border: 2.5px solid var(--brand-primary);
  padding: 0.5rem 2rem;
  border-radius: 8px;
}

h1 {
  font-size: 2rem;
  margin: 0;

  @media (min-width: 768px) {
    font-size: 2.5rem;
  }
}

.row {
  row-gap: 4rem;

  @media (max-width: 768px) {
    margin-top: 1rem;
  }
}

.option {
  display: flex;
  flex-direction: column;
  gap: 1rem;
  align-items: center;
  text-align: center;

  .option-icon {
    display: flex;
    flex-direction: column;
    justify-content: flex-end;

    @media (min-width: 992px) {
      height: 170px;
    }
  }

  &.start img {
    width: 70px;
  }

  &.share img {
    height: 170px;
  }

  h3 {
    margin: 0;
    max-width: 300px;
  }

  .option-text {
    max-width: 500px;
    padding: 0 1rem;

    @media (min-width: 768px) {
      font-size: 1.1rem;
      line-height: 1.8;
    }
  }

  .btn {
    @media (min-width: 768px) {
      margin-top: 1rem;
      font-size: 1.1rem;
    }
  }
}
</style>
